import { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { ThemeType } from 'styles/themes/KCFTheme';

export function GlobalThemeStyles() {
    const { colorMode } = useTheme();

    useEffect(() => {
        const html = document.documentElement;
        if (colorMode === ThemeType.dark) {
            html.classList.add('theme-dark');
            html.dataset.theme = 'dark';
        } else {
            html.classList.remove('theme-dark');
            delete html.dataset.theme;
        }
    }, [colorMode]);

    return null;
}
